import { z } from 'zod'

export const collectionMonthSchema = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/)
export const collectionPreviewSchema = z.strictObject({ billingMonth: collectionMonthSchema })
export const collectionExecuteSchema = z.strictObject({ planToken: z.uuid() })
export const collectionStatusSchema = z.strictObject({ runId: z.number().int().positive() })
export const collectionListSchema = z.strictObject({
  current: z.number().int().positive().default(1),
  pageSize: z.number().int().positive().max(20).default(10)
})
export const collectionAccountsSchema = z
  .array(z.strictObject({ organizationId: z.number().int().positive(), accountId: z.number().int().positive() }))
  .min(1)
  .max(100)
export const collectionPolicySchema = z.strictObject({
  customerId: z.number().int().positive(),
  expectedVersion: z.number().int().nonnegative(),
  enabled: z.boolean(),
  maxAmount: z.string().regex(/^(0|[1-9]\d{0,11})(\.\d{1,2})?$/),
  accounts: collectionAccountsSchema
})
export const collectionSendExistingSchema = z.strictObject({ groupId: z.number().int().positive() })
export const collectionWritePermissions = [
  'customer.read',
  'order.rental.read',
  'order.service.read',
  'bill.read',
  'bill.generate',
  'bill.issue',
  'bill.group.read',
  'bill.group.create',
  'bill.group.issue',
  'bill.group.send'
] as const

export const collectionRunListSchema = z.object({
  botId: z.uuid(),
  current: z.number().int().positive().default(1),
  pageSize: z.number().int().positive().max(100).default(20),
  id: z.number().int().positive().optional(),
  keyword: z.string().trim().max(100).optional(),
  status: z.enum(['preview', 'queued', 'issued', 'sent', 'failed']).optional(),
  createdFrom: z.iso.datetime().optional(),
  createdTo: z.iso.datetime().optional()
})
export const deliveryResolveSchema = z.strictObject({
  id: z.number().int().positive(),
  action: z.enum(['retry', 'confirm_sent']),
  reason: z.string().trim().min(5).max(500)
})

export const collectionSendPermissions = ['bill.group.read', 'bill.group.send'] as const

export const deliveryLeaseSchema = z.strictObject({
  id: z.number().int().positive(),
  leaseToken: z.uuid()
})
export const deliveryAcknowledgeSchema = deliveryLeaseSchema.extend({
  status: z.enum(['sent', 'unknown']),
  platformMessageId: z.string().max(255).optional()
})
